/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import * as ReverseImplementation from './reverse-implementation';
import BigHugeCircuit from './big-huge-circuit';
import BaseBigHugeCircuitGroup from '../../implementation-common/base-big-huge-circuit-group';

export default class MultipleFeedbackBigHugeCircuitGroup extends BaseBigHugeCircuitGroup {
  circuit;
  toleranceInput;
  reverseImplementation = ReverseImplementation;

  @computed('circuit', 'gbwArray', 'nominalValues', 'reverseImplementation') get circuits() {
    var circuit = this.circuit;
    var nominalGbw = circuit.opAmp.gbw;
    var nominalValues = this.nominalValues;
    var reverseImplementation = this.reverseImplementation;
    var c1ToleranceArray = circuit.c1.toleranceArray;
    var c2ToleranceArray = circuit.c2.toleranceArray;
    var r1ToleranceArray = circuit.r1.toleranceArray;
    var r2ToleranceArray = circuit.r2.toleranceArray;
    var c5ToleranceArray = circuit.c5.toleranceArray;

    var gbwArray = this.gbwArray;
    var bigHugeCircuitArray = [];
    gbwArray.forEach((gbwValue) => {
      r1ToleranceArray.forEach((r1Value) => {
        r2ToleranceArray.forEach((r2Value) => {
          c5ToleranceArray.forEach((c5Value) => {
            c1ToleranceArray.forEach((c1Value) => {
              c2ToleranceArray.forEach((c2Value) => {
                let item = BigHugeCircuit.create({
                  c1: c1Value,
                  c2: c2Value,
                  c5: c5Value,
                  r1: r1Value,
                  r2: r2Value,
                  opAmpGbw: gbwValue,
                  nominalValues: nominalValues,
                  nominalGbw: nominalGbw,
                  reverseImplementation: reverseImplementation,
                });
                bigHugeCircuitArray.push(item);
              });
            });
          });
        });
      });
    });

    var result = this.setNormalizers(bigHugeCircuitArray);
    return result;
  }
}
